/**
 * RateHoursBlock — heures saisies aux taux horaires additionnels de la fiche (ex. fin de semaine) : une ligne par taux,
 * colonnes rég. / × 1,5 / × 2. Les heures s'ajoutent à celles du taux principal (indemnité, primes, cotisations CCQ à l'heure, DAS).
 */
import { cellCls as cell, fmtCAD } from "./_shared";

const H = [["regular_hours", "Rég."], ["ot15_hours", "× 1,5"], ["ot2_hours", "× 2"]];

export const rateHoursBody = (rows) => (rows || []).filter((x) => x.code).map((x) => ({
  code: x.code, regular_hours: Number(x.regular_hours) || 0, ot15_hours: Number(x.ot15_hours) || 0, ot2_hours: Number(x.ot2_hours) || 0,
}));

export default function RateHoursBlock({ rates, rows, onChange, locked, eid, compact = false }) {
  if (!rates?.length) return null;
  const rowOf = (code) => (rows || []).find((x) => x.code === code) || { code, regular_hours: "", ot15_hours: "", ot2_hours: "" };
  const update = (code, k, v) => onChange([...(rows || []).filter((x) => x.code !== code), { ...rowOf(code), [k]: v }]);
  const total = (rows || []).reduce((a, x) => a + H.reduce((b, [k]) => b + (Number(x[k]) || 0), 0), 0);
  return (
    <div className={`rounded-lg border border-sky-200 bg-sky-50/40 ${compact ? "p-2" : "p-3"}`} data-testid={`paie-ts-rates-${eid}`}>
      <div className="text-[10px] font-bold uppercase text-sky-800 mb-1.5">
        Heures aux taux additionnels <span className="font-normal normal-case text-slate-500">(ligne de salaire distincte sur le bulletin ; s'ajoutent aux heures du taux principal saisies dans la ligne)</span>
      </div>
      <table className="text-xs">
        <thead><tr className="text-[10px] text-slate-500"><th className="text-left px-1 font-semibold">Taux</th>{H.map(([k, l]) => <th key={k} className="text-right px-1 font-semibold">{l}</th>)}</tr></thead>
        <tbody>
          {rates.map((r) => {
            const row = rowOf(r.code);
            return (
              <tr key={r.code} data-testid={`paie-ts-rate-row-${eid}-${r.code}`}>
                <td className="px-1 py-0.5 whitespace-nowrap"><b className="text-slate-800">{r.label}</b> <span className="text-slate-500 font-mono">· {fmtCAD(r.hourly_rate)}/h</span></td>
                {H.map(([k]) => (
                  <td key={k} className="px-1 py-0.5">
                    <input type="number" step="0.25" min="0" className={`${cell} w-20 text-right font-mono`} value={row[k] ?? ""} disabled={locked}
                      onChange={(e) => update(r.code, k, e.target.value)} data-testid={`paie-ts-rate-${k}-${eid}-${r.code}`} />
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
      {total > 0 && <p className="text-[10px] text-slate-500 mt-1" data-testid={`paie-ts-rates-total-${eid}`}>{total} h aux taux additionnels</p>}
    </div>
  );
}
